<template>
  <div>
    <HomePrograms/>
    <HomeStories/>
  </div>
</template>

<script>
  import HomePrograms from './HomePrograms';
  import HomeStories from './HomeStories';

  export default {
    components: {
      HomePrograms,
      HomeStories,
    },
  };
</script>

<style
  lang="scss"
  scoped
>
</style>
